import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const StudyIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M50.2296 18.7356V29.4563" stroke={props.htmlColor || "#FFCB06"} strokeWidth="3"/>
      <path d="M6.64406 18.6937L28.5459 9.26367L50.4478 18.6937L28.5459 27.211L6.64406 18.6937Z" stroke={props.htmlColor || "black"}/>
      <path d="M28.4067 48.6003C25.0676 45.3961 19.5471 43.4731 15.0059 44.3644L14.5948 44.4451L17.5951 27.2112L28.4078 31.4133L39.2133 27.2112L42.2136 44.4451L41.8024 44.3644C37.2613 43.4731 31.6014 45.5325 28.2623 48.7367" stroke={props.htmlColor || "black"} />
    </SvgIcon>
  );
};

export default StudyIcon;
